export { default } from "ember-stereo/-private/utils/sound-cache";
